// extracted by mini-css-extract-plugin
export var container = "simple-roi-calculator-module--container--be284";
export var ctaContainer = "simple-roi-calculator-module--ctaContainer--0f433";
export var hoursDisplay = "simple-roi-calculator-module--hoursDisplay--a1472";
export var resultCard = "simple-roi-calculator-module--resultCard--48d31";
export var slider = "simple-roi-calculator-module--slider--77008";
export var sliderContainer = "simple-roi-calculator-module--sliderContainer--7bd6f";
export var sliderLabels = "simple-roi-calculator-module--sliderLabels--51c13";